import { Table, Tag, Empty } from "antd";
import trans from "../../../../utils";

export function TeamsAssignedTab({ data }) {
  const columns = [
    {
      title: trans("Team Code"),
      dataIndex: "code",
      key: "code",
      render: (_, record) => record?.team?.code || "-",
    },
    {
      title: trans("Team Name"),
      dataIndex: "name",
      key: "name",
      render: (_, record) => record?.team?.name || "-",
    },
    {
      title: trans("Company"),
      dataIndex: "companyName",
      key: "companyName",
      render: (_, record) => record?.team?.companyProject?.company?.name || "-",
    },
    {
      title: trans("Project"),
      dataIndex: "projectName",
      key: "projectName",
      render: (_, record) => record?.team?.companyProject?.project?.name || "-",
    },
    {
      title: trans("Status"),
      dataIndex: "status",
      key: "status",
      render: (_, record) =>
        record?.team?.status === "ACTIVE" ? (
          <Tag color="green">{trans("Active")}</Tag>
        ) : (
          <Tag color="red">{trans("Inactive")}</Tag>
        ),
    },
    {
      title: trans("Role"),
      dataIndex: "role",
      key: "role",
      render: (_, record) => record?.team?.companyProject?.role || "-",
    },
    {
      title: trans("Trades"),
      dataIndex: "trades",
      key: "trades",
      render: (_, record) => record?.team?.trades?.map((trade) => trade.name).join(", ") || "-",
    }
  ];

  if (!data?.teamMemberships || data?.teamMemberships.length === 0) {
    return <Empty description={trans("No teams assigned")} />;
  }

  return (
    <Table
      columns={columns}
      dataSource={data?.teamMemberships}
      rowKey={(record) => record.id}
      pagination={false}
      size="small"
      scroll={{ y: 400 }}
    />
  );
}
